import { useEffect, useState } from 'react';
import api from '../services/api';
import { normalizarId } from './useScope';

export interface ParceiroOpcao {
  partnerId: number;
  partnerName: string;
}

/**
 * Lista de parceiros para os seletores de vínculo.
 *
 * NOMES DOS CAMPOS: cada entidade prefixa o próprio. No parceiro são
 * `partnerId` / `partnerName`; no proprietário, `tenantPartnerId` /
 * `tenantPartnerName`; no usuário, `userPartner` / `userPartnerName`. Não há
 * reserva cruzada de propósito — ler o campo de outra entidade seria chute.
 *
 * Só busca quando `ativo`: quem não pode escolher o parceiro não precisa da
 * lista, e pedi-la à toa só gera requisição que o servidor pode negar.
 */
export const useListaParceiros = (ativo: boolean) => {
  const [parceiros, setParceiros] = useState<ParceiroOpcao[]>([]);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    if (!ativo) return;
    let vivo = true;
    setCarregando(true);
    api
      .get('/partner')
      .then((resp) => {
        if (!vivo) return;
        const bruto = Array.isArray(resp.data)
          ? resp.data
          : resp.data?.partners ?? resp.data?.data ?? [];
        const lista: ParceiroOpcao[] = (bruto as any[])
          .map((p) => ({
            // ZERO é o grupo raiz, não ausência — por isso normalizarId.
            partnerId: normalizarId(p?.partnerId),
            partnerName: p?.partnerName?.toString().trim() || '',
          }))
          .filter((p): p is ParceiroOpcao => p.partnerId !== null);
        setParceiros(lista);
        setErro(false);
      })
      .catch(() => {
        if (vivo) setErro(true);
      })
      .finally(() => {
        if (vivo) setCarregando(false);
      });
    return () => {
      vivo = false;
    };
  }, [ativo]);

  return { parceiros, carregando, erro };
};
